<section *ngIf="!isOpened">
  <div class="row">
    <form class="needs-validation container-style" novalidate [formGroup]="formIcaRate">
      <div class="ps-2 pe-2">
        <div class="row pt-1">
          <div class="col">
            <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
              [width]="'6rem'" [routerLink]="['/', url]" [severity]="null"></app-custom-button>
          </div>
          <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
          </div>

          <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
            <app-custom-button [title]="'Eliminar'" [icon]="'pi pi-trash'" [severity]="'contrast'"
              (onClick)="delete()"></app-custom-button>

            <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'" [width]="'5.5rem'"
              [severity]="'success'" [variant]="undefined" (onClick)="createNewRegister()"></app-custom-button>
          </div>
          <hr class="my-1">
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <app-custom-audit-info [userNameCreate]="icaRateContract.userNameCreate"
              [createDate]="icaRateContract.createDate" [userNameUpdate]="icaRateContract.userNameUpdate"
              [updateDate]="icaRateContract.updateDate" [reserveSpace]="true"></app-custom-audit-info>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-12">
          <div class="row">
            <div class="col field-city">
              <app-custom-inputgroup [inputValue]="city" [labelText]="'Ciudad'" [iconButton]="'pi pi-external-link'"
                [titleButton]="'Seleccionar Ciudad'" [required]="true" [recovery]="true"
                (onClick)="openCitySelectionModal()"></app-custom-inputgroup>
              <app-custom-modal #selectCity [label]="'Seleccionar'" [header]="'Selección de Ciudades'"
                [children]="componentCitySelection" [inputs$]="inputsForSelectCityModal$" [output$]="output$"
                (selectedItems)="changeCity($event)" hidden></app-custom-modal>
            </div>
            <div class="col field-department">
              <app-custom-input-text [value]="department" [labelText]="'Departamento'"
                [disabled]="true"></app-custom-input-text>
            </div>
            <div class="col field-conceptInvoicing">
              <app-custom-select formControlName="conceptInvoicingId" [labelText]="'Concepto Fra.'"
                [list]="listConceptInvoicing" [required]="true" [recovery]="true"
                (onChangeSelect)="changeConcept($event)">
              </app-custom-select>
            </div>
            <div class="col field-rate">
              <app-custom-input-decimal formControlName="rate" [labelText]="'Tarifa'"></app-custom-input-decimal>
            </div>
            <div class="col field-inimumBase">
              <app-custom-input-decimal formControlName="minimumBase"
                [labelText]="'Base Miníma'"></app-custom-input-decimal>
            </div>
            <div class="col field-code">
              <app-custom-input-text formControlName="code" [labelText]="'Código'" [maxLength]="10">
              </app-custom-input-text>
            </div>
            <div class="col field-saleAccount">
              <app-custom-input-text formControlName="saleAccount" [labelText]="'Cuenta Venta'" [maxLength]="10">
              </app-custom-input-text>
            </div>
            <div class="col field-saleDevolutionAccount">
              <app-custom-input-text formControlName="saleDevolutionAccount" [labelText]="'Cuenta Vta. Dev'"
                [maxLength]="10">
              </app-custom-input-text>
            </div>
            <div class="col field-payAccountSelfWithholdingICA">
              <app-custom-input-text formControlName="payAccountSelfWithholdingICA" [labelText]="'CxP Auto.Rt.Ica'"
                [maxLength]="10">
              </app-custom-input-text>
            </div>
            <div class="col field-devolutionAccountSelfWithholdingICA">
              <app-custom-input-text formControlName="devolutionAccountSelfWithholdingICA"
                [labelText]="'CxP Dev.Auto.Rt.Ica'" [maxLength]="10">
              </app-custom-input-text>
            </div>
            <div class="col field-send">
              <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [severity]="'primary'" [variant]="undefined"
                [disabled]="disabledForm" (onClick)="send()">
              </app-custom-button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>
<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>